import React, { useEffect, useState }  from 'react';
import { observer, useObserver } from "mobx-react";
import { Box, Button, Card, CardContent, CardHeader, CircularProgress, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, TextField } from '@material-ui/core';
import { stores } from 'mobx-store';
import { RequestStatus } from 'components/GeneralFormView/types';
import Snackbar from '@material-ui/core/Snackbar';
import * as styles from './styles.module.scss';
import ButtonState from 'components/ButtonStateComponent';
import { RegistrationFlow } from './types';
import { translate } from 'helperFunctions/translation';
const MobileUserRegistration: React.FC = () => {
    // validation messages states
    const [open, setOpen] = useState(false);
    const [msg, setMsg] = useState('');
    // registration flow states
    const [registerationState, setRegisterationState] = useState(RegistrationFlow.MEMBERSHIP_VERIFICATION);
    // stores
    const { userManagementStore } = stores;

    useEffect(() => {
        userManagementStore.registrationRequest = {};
    }, []);
  

   
    const MemberShipVerificatio = () => {
        const [membershipId, setMembershipId] = useState('');
        const memberVerificationClicked = async () => {
            try {
                await userManagementStore.memberShipVerification(membershipId);
                setMsg(translate("verified"));
                setRegisterationState(RegistrationFlow.METHOD_SELECTION);
            } catch (error) {
             setMsg(error || translate("invalidValue"));  
            } finally{
                setOpen(true)
            }
        };
        return useObserver(() =>  (
        <Card className={styles.card}>
            <TextField
                value={membershipId}
                onChange={(e) => setMembershipId(e.target.value)}
                autoFocus
                placeholder={translate("membershipId")}
                margin="dense"
                id="membershipId"
                fullWidth
            />
            <ButtonState
                loading={userManagementStore.state === RequestStatus.LOADING}
                disabled={!membershipId}
                onClick={memberVerificationClicked}
            >
                verify
            </ButtonState>
        
        </Card>
        ));
    };

    const PhoneNumberSelection = () => {
        const [phoneType, setPhoneType] = useState('');
        const { mobileUser } = userManagementStore;
        const methodSelectionClicked = async () => {
            try {
                await userManagementStore.phoneNumberSelection(phoneType);
                setMsg(translate("selected"));
                setRegisterationState(RegistrationFlow.PHONE_REGISTRATION);
            } catch (error) {
             setMsg(error || translate("invalidValue"));  
            } finally{
                setOpen(true)
            }
        };
        return useObserver(() =>  (
            <Card className={styles.card}>
                <FormControl component="fieldset">
                    <FormLabel component="legend">{translate("phoneSelection")}</FormLabel>
                    <RadioGroup aria-label="gender" name="gender1" value={phoneType} onChange={(e) => setPhoneType(e.target.value)}>
                        {
                            mobileUser.firstMobile &&
                            <FormControlLabel value="first" control={<Radio />} label={mobileUser.firstMobile} />
                        }
                        {
                            mobileUser.secondMobile && 
                            <FormControlLabel value="second" control={<Radio />} label={mobileUser.secondMobile} />
                        }
                    </RadioGroup>
                </FormControl>
                <br/>
                <ButtonState
                    loading={userManagementStore.state === RequestStatus.LOADING}
                    disabled={!phoneType}
                    onClick={methodSelectionClicked}
                >
                {translate("verify")}
            </ButtonState>
            </Card>
        ));
    };

    const PhoneNumberRegsteration = () => {
        const [email, setEmail] = useState('');
        const [password, setPassword] = useState('');
        const registerUser = async () => {
        try {
            await userManagementStore.registerMobileUser(email, password);
            setMsg(translate("registred"));
            setRegisterationState(RegistrationFlow.MEMBERSHIP_VERIFICATION);
        } catch (error) {
              setMsg(error || translate("invalidValue"));  
        } finally {
                setOpen(true)
            }
        };
        return useObserver(() =>  (
            <Card className={styles.card}>
            <TextField
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoFocus
                margin="dense"
                id="email"
                label={translate("loginScreen.email")}
                fullWidth
            />
            <TextField
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoFocus
                margin="dense"
                id="password"
                type="password"
                label={translate("loginScreen.password")}
                fullWidth
            />
                <ButtonState
                    loading={userManagementStore.state === RequestStatus.LOADING}
                    disabled={!email || !password}
                    onClick={registerUser}
                >
                    {translate("Submit")}
                </ButtonState>
            </Card>
        ));
    };
    const RegistrationSteps = (props: {state: RegistrationFlow}) => {
        const { state } = props;
        if(state === RegistrationFlow.MEMBERSHIP_VERIFICATION) {
            return <MemberShipVerificatio />;
        }
        if(state === RegistrationFlow.METHOD_SELECTION) {
            return <PhoneNumberSelection />
        }
        if(state === RegistrationFlow.PHONE_REGISTRATION) {
            return <PhoneNumberRegsteration />
        }
        return null;
    };


    return useObserver(() => (
        <div className={styles.container}>
            <RegistrationSteps state={registerationState} />
            <Snackbar
                open={open} 
                autoHideDuration={6000}
                onClose={() => setOpen(false)}
                message={msg}
            />
        </div>
    ));
}
export default MobileUserRegistration;